import { jsx as _jsx } from "react/jsx-runtime";
import Icon from './Icon';
const CardIcon = ({ icon }) => {
    return (_jsx("div", { className: "flex items-center justify-center w-12 h-12 text-white transition-all duration-200 bg-gold group-hover:bg-green", children: _jsx("div", { className: "w-6", children: _jsx(Icon, { name: icon }) }) }));
};
export default CardIcon;
